import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Shield } from 'lucide-react';
import { TermlyScriptWrapper } from './TermlyScriptWrapper';

export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <Helmet>
        <title>Privacy Policy - RoyaltySuite</title>
        <meta name="description" content="Learn about how RoyaltySuite protects and handles your personal information." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="flex items-center gap-3 mb-8">
        <div className="relative">
          <div className="absolute inset-0 bg-royal-purple/20 rounded-full blur-lg" />
          <Shield className="w-8 h-8 text-royal-purple relative" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Privacy Policy</h1>
      </div>

      <div className="bg-white dark:bg-dark-paper rounded-xl shadow-sm">
        <div className="p-8">
          <TermlyScriptWrapper 
            policyId="946d0c07-fee1-4cf1-9f5e-b7eda45862b9"
            className="min-h-[800px]"
          />
        </div>
      </div>
    </div>
  );
}